
$(document).on('content-ready', function (ev, container) {
    container.find('#invitation-positions-card input,#invitation-positions-card textarea').change((ev) => {
        var inputEl = $(ev.currentTarget);
        var priceRowEl = inputEl.closest('[data-id]');

        if (priceRowEl.find('[name="Amount"]').length && priceRowEl.find('[name="Amount"]').val().trim() === '') {
            priceRowEl.find('[name="Amount"]').val(1);
        }
        if (inputEl.is('[name="PricePer"]') || inputEl.is('[name="Amount"]')) {
            var price = priceRowEl.find('[name="PricePer"]').val() * (priceRowEl.find('[name="Amount"]').val() || priceRowEl.find('[data-amount]').attr('data-amount'));
            var priceFormated = price.toFixed(2);
            priceRowEl.find('[name="Price"]').val(priceFormated);
            priceRowEl.find('[name="Price"]').change();
        }
        connection.getJson('/Devis/Invitation/UpdatePrice', {
            type: 'POST',
            data: {
                positionId: inputEl.closest('[data-id]').attr('data-id'),
                linkHash: $('#InvitationHash').val(),
                data: JSON.stringify({
                    pricePer: priceRowEl.find('[name="PricePer"]').val(),
                    price: priceRowEl.find('[name="Price"]').val(),
                    amount: priceRowEl.find('[name="Amount"]').val(),
                    notice: priceRowEl.find('[name="Notice"]').val(),
                }),
            },
            onSuccess: (response) => {
                messaging.showGlobalMessage('success', null, 'Die Änderung wurde gespeichert.');
            },
            onError: (response) => {
                messaging.showGlobalMessage('danger', null, 'Es ist ein Fehler aufgetreten.');
            },
        });
    });
    container.find('#invitation-conditions input').change((ev) => {
        var data = {};
        $.each(container.find('#invitation-conditions input'), function() {
            var me = $(this);
            data[me.attr('name')] = {"amount": me.val()};
        });
        connection.getJson('/Devis/Invitation/UpdateConditions', {
            type: 'POST',
            data: {data: data},
            onSuccess: (response) => {
                messaging.showGlobalMessage('success', null, 'Die Änderung wurde gespeichert.');
                recalculateConditions();
            },
            onError: (response) => {
                messaging.showGlobalMessage('danger', null, 'Es ist ein Fehler aufgetreten.');
            },
        });
    });

    function recalculateConditions() {
        var currentSum = $('#overview-totals [data-total]').sum('data-total');

        $.each($('#invitation-conditions [data-type]'), (i, el) => {
            var type = $(el).attr('data-type');
            var inputEl = $(el).find('input');
            if (type === "total") {
                $(el).find('.total-field').html(currentSum.FormatNumberForDisplay(2));
            } else if (type === "rabatt") {
                currentSum -= currentSum * (parseFloat(inputEl.val() || "0") / 100);
            } else if (type === "plus") {
                currentSum += currentSum * (parseFloat(inputEl.val() || "0") / 100);
            }
        });
    }
    recalculateConditions();

    container.find('[data-catalog-price]').change((ev) => {
        var catalogId = $(ev.target).attr('data-catalog-price');
        var subtotal = container.find(`[data-catalog-price="${catalogId}"]`).sum();
        container.find(`[data-subtotal="${catalogId}"] [data-total]`)
            .attr('data-total', subtotal)
            .html(subtotal.FormatNumberForDisplay(2));

        var total = $(`#devis-positions-table [data-subtotal] [data-total]`).sum('data-total');
        $(`#devis-positions-table [data-devis-total] [data-total]`)
            .attr('data-total', total)
            .html(total.FormatNumberForDisplay(2));
        recalculateConditions();
    });

    if (container.find('.fixed-table-headers').length) {
        let options = {
            root: container.find('.fixed-table-headers')[0],
            rootMargin: '0px',
            threshold: 0,
        }
        let targets = container.find('.scroll-container tbody[data-catalog-part]');
        let observer = new IntersectionObserver((entries, observer) => {
            var lastEl = $(targets[0]);
            $.each(targets, (i, target) => {
                if ($(target).position().top < 0) {
                    lastEl = $(target);
                }
            });
            $('[data-catalog-number]').html(lastEl.find('.catalog-number').html());
            $('[data-catalog-name]').html(lastEl.find('.catalog-name').html());
        }, options);
        $.each(targets, (i, target) => {
            observer.observe(target);
        });
    }
});